import { __awaiter, __generator, __read, __values } from "tslib";
import { createContext } from './query-job';
import BinarySearch from '../algorithm/binary-search';
var QueryJobDistinct = /** @class */ (function () {
    function QueryJobDistinct(node, parent) {
        this.node = node;
        this.parent = parent;
        this.context = createContext(node);
    }
    QueryJobDistinct.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            var searcher, _a, _b, pointers, isOccurredMap, sortedKeys, distinctPointers, pointers_1, pointers_1_1, pointer, _c, key, index;
            var e_1, _d, e_2, _e;
            return __generator(this, function (_f) {
                searcher = new BinarySearch(this.node.comparer);
                try {
                    for (_a = __values(this.context.inputs), _b = _a.next(); !_b.done; _b = _a.next()) {
                        pointers = _b.value;
                        isOccurredMap = new Map();
                        sortedKeys = pointers.map(function (_a) {
                            var _b = __read(_a, 1), key = _b[0];
                            return key;
                        }).sort(this.node.comparer.cmp);
                        distinctPointers = [];
                        try {
                            for (pointers_1 = (e_2 = void 0, __values(pointers)), pointers_1_1 = pointers_1.next(); !pointers_1_1.done; pointers_1_1 = pointers_1.next()) {
                                pointer = pointers_1_1.value;
                                _c = __read(pointer, 1), key = _c[0];
                                index = searcher.getOrder(sortedKeys, key);
                                if (isOccurredMap.has(index)) {
                                    continue;
                                }
                                isOccurredMap.set(index, true);
                                distinctPointers.push(pointer);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (pointers_1_1 && !pointers_1_1.done && (_e = pointers_1.return)) _e.call(pointers_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        output.push(distinctPointers);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    return QueryJobDistinct;
}());
export { QueryJobDistinct };
export default QueryJobDistinct;
//# sourceMappingURL=query-job-distinct.js.map